import { render, staticRenderFns } from "./SendToDoubtfulReceivables.vue?vue&type=template&id=ec9c29b4&scoped=true&"
import script from "./SendToDoubtfulReceivables.vue?vue&type=script&lang=js&"
export * from "./SendToDoubtfulReceivables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9c29b4",
  null
  
)

export default component.exports